import React, { Component } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Navbar, Nav, NavDropdown, Form, FormControl, Button } from 'react-bootstrap'

class Header extends Component {
  constructor(props) {
    super(props);
    //console.log(props.location.pathname);
    // console.log(props.location);
  }
  render() {

    return (
      <div className="main-menu">
        {/* <Link className="navbar-brand logo" to="/">&lt;Mac/&gt;</Link>
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button> */}

        {/* <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item">
              <NavLink activeClassName="active" exact className="nav-link" to="/">&lt;Home /&gt;</NavLink>
            </li>
            <li className="nav-item">
              <NavLink activeClassName="active" className="nav-link" to="/about">&lt;About /&gt;</NavLink>
            </li>
            <li className="nav-item">
              <NavLink activeClassName="active" className="nav-link" to="/experience">&lt;Experience /&gt;</NavLink>
            </li>
            <li className="nav-item">
              <NavLink activeClassName="active" className="nav-link" to="/contact">&lt;Contact /&gt;</NavLink>
            </li>
          </ul>
        </div> */}
        <Navbar variant="light" expand="lg" fixed="top" collapseOnSelect="true">
          <Navbar.Brand href="#home" className="logo">&lt;Mac/&gt;</Navbar.Brand>
          <Navbar.Toggle aria-controls="main-menu-nav" as="div">
            <div className="menu-btn">
              <div></div><div></div><div></div>
            </div>
          </Navbar.Toggle>
          <Navbar.Collapse id="main-menu-nav">
            <Nav className="ml-auto">
              <Nav.Link className={window.location.hash == "#" ? "active" : ""} href="#">&lt;Home /&gt;</Nav.Link>
              <Nav.Link className={window.location.hash == "#about" ? "active" : ""} href="#about">&lt;About /&gt;</Nav.Link>
              <Nav.Link className={window.location.hash == "#experience" ? "active" : ""} href="#experience">&lt;Experience /&gt;</Nav.Link>
              <Nav.Link className={window.location.hash == "#works" ? "active" : ""} href="#works">&lt;Works /&gt;</Nav.Link>
              <Nav.Link className={window.location.hash == "#contact" ? "active" : ""} href="#contact">&lt;Contact /&gt;</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </div>
    );
  }
}
export default Header;
